<template>
  <div class="d-flex hm-date-select">
    <DateRangePicker
      ref="picker"
      v-model="dateRange"
      :dateRange="dateRange"
      opens="left"
      :locale-data="{
        format: 'mm/dd/yyyy',
        separator: ' - ',
        firstDay: 1,
      }"
      :singleDatePicker="true"
      :timePicker="showTime"
      :timePicker24Hour="false"
      :showWeekNumbers="false"
      :showDropdowns="false"
      :autoApply="!showTime"
      :disabled="disabled"
      :ranges="false"
      :minDate="minDate"
    >
      <template #input="picker">
        <slot>
          <div class="form-control">
            <i 
              class="calendar-icon far fa-calendar"
            ></i>
            {{ toDate(picker.startDate) }}
          </div>
        </slot>
      </template>
    </DateRangePicker>
    <HMIconButton v-if="showClear" :icon="['far', 'fa-times']" @click="clear" />
  </div>
</template>

<script lang="ts">
import DateRangePicker from 'vue3-daterange-picker';
// import 'vue3-daterange-picker/dist/vue3-daterange-picker.css';
import moment from '@/services/moment';

export default {
  name: 'HMDateSelect',
  components: {
    DateRangePicker,
  },
  props: {
    modelValue: {
      type: Object as () => DatePicker,
      default: () => ({
        startDate: null,
        endDate: null,
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showClear: {
      type: Boolean,
      default: false,
    },
    hideDefaultDateRanges: {
      type: Boolean,
      default: false,
    },
    showTime: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default: null,
    },
    openPicker: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateRange: {
        startDate: null,
        endDate: null,
      } as DatePicker,
    };
  },
  mounted() {
    // this.dateRange = this.modelValue;
    if (this.openPicker) {
      setTimeout(() => {
        this.$refs.picker.togglePicker(true);
        this.$refs.picker.dateClick(this.modelValue.startDate);
      }, 30);
    }
  },
  watch: {
    dateRange: {
      handler(modelValue: DatePicker) {
        this.$emit('update:modelValue', modelValue);
      },
    },
  },
  methods: {
    clear(): void {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
    },
    toDate: function (value: Date): string {
      if (!value) return '';
      return moment(value).format('MMM DD, yyyy');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.calendar-icon {
  color: var(--brand-color, $coral);
  margin-right: 0.5rem;
}
</style>
<style lang="scss">
.hm-date-select .vue-daterange-picker {
  width: 100%;

  @import '@/styles/components-variables.scss';
  .vue-daterange-picker {
    width: 100%;
  }
  .reportrange-text {
    // margin: auto !important;
    padding: 0;
    height: auto;
    border: none;
  }
  .daterangepicker td.active,
  .daterangepicker td.active:hover {
    background: $coral;
  }
  .ranges li.active {
    background-color: var(--brand-color, $coral);
  }
}
</style>
